<template>
  <b-card
    @click="select"
    body-class="p-3 h-100"
    class="timesheet-summary text-center mb-4 text-uppercase card-box-alt card-box-hover-rise card-box-hover w-100"
    :class="[{'selected-timesheet': isSelected}, {'error-timesheet': error},  {'card-shadow-freelancer': isFreelancer()}]"
  >

    <b-form-checkbox
      v-if="!noSelect"
      :checked="isSelected"
      class="position-absolute"
      @change="select"
    />
    <b-row>
      <b-col class="text-left">
        <div class="card-badges">
          <b-badge
            :variant="timesheet.IsOvertimed.toLowerCase() === 'no' ? 'success' : 'danger'"
          >
            <i v-if="timesheet.IsOvertimed.toLowerCase() !== 'no'" :class="this.$getConst.icons.exclamation_circle"></i>
            {{formatTotalUnits(timesheet.TotalUnits, unit)}} {{unit.toLowerCase() === "hour" ? 'h' : 'd' }}
          </b-badge>
        </div>
        <h5 class="text-primary font-weight-bold">{{$t($getConst.pages.timesheet.timesheet_start_date)}}</h5>
        <h6 class="text-secondary font-weight-bold mb-3" :class="{' ml-lg-5': isFreelancer()}">{{timesheet.StartDate | localDate}}</h6>
      </b-col>
    </b-row>
    <b-row class="flex-grow-1 px-3">
      <b-col cols="10" class="pl-0 text-left">

        <div class="mb-3">
          <timesheet-row
            v-if="isApprover()"
            :label="$t($getConst.pages.timesheet.timesheet_worker_name)"
            :content="workerName"
          />
          <timesheet-row
            :label="$t($getConst.pages.timesheet.timesheet_contract_number)"
            :content="contractId"
          />
          <timesheet-row
            v-if="isWorker() || isFreelancer()"
            :label="$t($getConst.pages.timesheet.timesheet_organisation)"
            :content="companyName"
          />
          <timesheet-row
            :label="$t($getConst.pages.timesheet.timesheet_role)"
            :content="jobTitle"
          />
        </div>
        <h5 class="text-primary font-weight-bold mb-0">
          {{$t($getConst.pages.timesheet.timesheet_status)}}
          <span class="text-secondary float-right">{{timesheet.status}}</span>
        </h5>
      </b-col>
      <b-col cols="2" class="pr-0 text-center d-flex flex-column">
        <div class="my-auto">
          <AppSvgIcon
            v-if="timesheet.status === 'Open'"
            height="2.5rem"
            :icon="$getConst.svgIcons.clock_checked"
          />
          <AppSvgIcon
            v-if="timesheet.status === 'Approved' || timesheet.status === 'Proceed'"
            height="2.5rem"
            :icon="$getConst.svgIcons.clock_checked_success"
          />
          <AppSvgIcon
            v-if="timesheet.status === 'Returned' || timesheet.status === 'Returned by Hays'"
            height="2.5rem"
            :icon="$getConst.svgIcons.clock_checked_danger"
          />
          <AppSvgIcon
            v-if="timesheet.status === 'Saved'"
            height="2.5rem"
            :icon="$getConst.svgIcons.clock_checked_blue"
          />
          <AppSvgIcon
            v-if="timesheet.status === 'Submitted'"
            height="2.5rem"
            :icon="$getConst.svgIcons.clock_checked_orange"
          />
        </div>
        <div class="mt-auto">
          <b-button v-if="isFreelancer()" @click="sendTimesheet" variant="outline"><i :class="$getConst.icons.externalLink + ' fa-lg text-primary'"/></b-button>
          <b-button v-else @click="sendTimesheet"><i :class="$getConst.icons.chevron_right"/></b-button>
        </div>
      </b-col>
      <p v-if="error" class="mb-0 text-danger mx-auto error-timesheet-message">{{error.Error}}</p>
    </b-row>

  </b-card>
</template>

<script>
  import TimesheetRow from "./_timesheetRow";
  export default {
    name: "AppTimesheet",
    components: {TimesheetRow},
    props: {
      countryId: null,
      contractId: null,
      companyName: null,
      workerName: null,
      jobTitle: null,
      unit: null,
      timesheet: {
        type: Object,
        required: true
      },
      isSelected: {
        type: Boolean,
        default: false
      },
      noSelect: {
        type: Boolean,
        default: false
      },
      error: null
    },
    methods: {
      sendTimesheet() {
        this.$emit("click", {
          timesheetId: this.timesheet.id,
          navScopeId: this.countryId
        })
      },
      select() {
        if (!this.noSelect) {
          this.$emit("select", {
            timesheetId: this.timesheet.id,
            navScopeId: this.countryId
          })
        }
      },
      formatTotalUnits(total, unit) {
        const decimalPart = total.split(".")[1];

        if (decimalPart && parseInt(decimalPart) > 0 && unit.toLowerCase() === "hour") {
          return parseFloat(total).toFixed(2);
        } else if(decimalPart && parseInt(decimalPart) > 0) {
          return parseFloat(total).toFixed(1);
        }

        return parseFloat(total);
      }
    }
  }
</script>

<style scoped>

</style>
